var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('Modal', {
    staticClass: "info-message",
    attrs: {
      "title": $t("a6u45a4", "个人信息"),
      "mask-closable": false,
      "width": "500"
    },
    on: {
      "on-cancel": _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "contain"
  }, [_c('div', {
    staticClass: "register_column_item"
  }, [_c('ProForm', {
    ref: "form",
    attrs: {
      "label-position": "top",
      "columns": _vm.columns
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1)]) : _vm._e(), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v($t("kzjg2", "确定"))])], 1)]), _c('bindMobile', {
    ref: "bindMobile",
    attrs: {
      "visible": _vm.bindInfo.visible
    },
    on: {
      "updateMobile": _vm.updateMobile
    }
  }), _c('changeBind', {
    ref: "changeBind",
    attrs: {
      "visible": _vm.changeBindInfo.visible
    },
    on: {
      "updateMobile": _vm.updateMobile
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };